import styled from 'styled-components';

export const PhoneContainer = styled.div`
  display: flex;
  margin-top: 1rem;
  flex-direction:column;
  /* .react-tel-input { */
    /* .form-control {
      &:focus {
        border-color: ${({ theme, color }) => theme && theme[color].main};
        box-shadow: 0 0 0 1px ${({ theme, color }) => theme && theme[color].main};
        & + div {
          &:before {
            color: ${({ theme, color }) => theme && theme[color].main};
          }
        }
      }
      & + div {
        &:before {
          content: ${({ label }) => `'${label}'`};
        }
      }
    } */
  /* } */
`;
